import { useTranslation } from 'react-i18next';

import { usePermissions } from '@nucleus-commerce/admin-kit/permissions';

import { useConversationCounts } from '../hooks/use-conversation-counts';

/**
 * The sidebar count: open or pending conversations that are unassigned or assigned to me, across
 * every store. Refreshed once a minute like the bell; live while the inbox is open.
 */
export function InboxNavBadge() {
  const { t } = useTranslation('conversations');
  const { can } = usePermissions();
  const allowed = can('conversations.read');
  const counts = useConversationCounts({ refetchIntervalMs: 60_000, enabled: allowed });
  const total = counts.data?.items.reduce((sum, item) => sum + item.unassigned + item.mine, 0) ?? 0;
  if (!allowed || total === 0) return null;
  return (
    <span className="tabular-nums" aria-label={t('nav.badge', { count: total })}>
      {total > 99 ? '99+' : total}
    </span>
  );
}
